import { isNumber } from 'lodash';
import {
    accountNumberRegex,
    checkForOnlyAlphabets,
    emailRegex,
    isAlphaNumeric,
    numberRegex,
    panRegex,
} from '../../../../utils/constants';

const panRegexTest = (value: string) => {
    return panRegex.test(value) ? '' : 'Invalid PAN';
};
const emailRegexTest = (value: string) => (emailRegex.test(value) ? '' : 'Invalid Email');

const pinCodeTest = (value: string) => {
    if (!numberRegex.test(value)) return 'Only numbers allowed';
    if (value.length !== 6) return 'Pincode should be of length 6';
    return '';
};

const mobileTest = (value: string) => {
    if (!numberRegex.test(value)) return 'Only numbers allowed';
    if (value.length !== 10) return 'Mobile number should be 10 digits';
    return '';
};

const requiredTest = (key: string) => (value: string) => {
    if (!value) return `${key} is required`;
    return '';
};

const numberTest = (value: string) => {
    return numberRegex.test(value) ? '' : 'Only numbers allowed';
};

const accountNumberTest = (value: string) => {
    return accountNumberRegex.test(value) ? '' : 'Invalid Account Number';
};

const alphabetTest = (value: string) => {
    return checkForOnlyAlphabets(value) ? '' : 'Only alphabets allowed';
};

const pekrnTest = (value: string) => {
    if (value.length < 9) {
        return 'Minimum length is 9 characters';
    }
    if (value.length > 12) {
        return 'Maximum length is 12 characters';
    }
    return '';
};

export enum ObjectiveDetail {
    PAN = 'PAN',
    Email = 'Email',
    Mobile = 'Mobile No',
    DOB = 'Date of Birth',
    BankAccountNumber = 'Bank Account Number',
    Pekrn = 'PEKRN',
    None = 'None',
    // Folio = 'Folio'
    // City = 'City',
    // PinCode = 'Pincode',
}

export enum SubjectiveDetail {
    Address = 'Address',
    NomineeName = 'Nominee Name',
    City = 'City',
    PinCode = 'Pincode',
}

export const getObjectiveDetailOptions: { [key: string]: ObjectiveDetail } = {
    '0': ObjectiveDetail.PAN,
    '1': ObjectiveDetail.Email,
    '2': ObjectiveDetail.Mobile,
    '3': ObjectiveDetail.DOB,
    '4': ObjectiveDetail.BankAccountNumber,
};

export const getSubjectiveDetailOptions: { [key: string]: SubjectiveDetail } = {
    '0': SubjectiveDetail.City,
    '1': SubjectiveDetail.Address,
    '2': SubjectiveDetail.PinCode,
    '3': SubjectiveDetail.NomineeName,
};

export const validations: { [key: string]: Array<(value: string) => string> } = {
    [ObjectiveDetail.PAN]: [requiredTest('PAN'), panRegexTest],
    [ObjectiveDetail.Pekrn]: [requiredTest('PEKRN'), pekrnTest],
    [ObjectiveDetail.Mobile]: [requiredTest('Mobile'), mobileTest],
    [ObjectiveDetail.Email]: [requiredTest('Email'), emailRegexTest],
    [ObjectiveDetail.DOB]: [requiredTest('Date of Birth')],
    [ObjectiveDetail.BankAccountNumber]: [requiredTest('Account No')],
    // [SubjectiveDetail.Folio]: [requiredTest('Folio'), numberTest],
    [SubjectiveDetail.PinCode]: [requiredTest('PinCode'), pinCodeTest],
    [SubjectiveDetail.City]: [requiredTest('City'), alphabetTest],
    [SubjectiveDetail.Address]: [requiredTest('Address')],
    [SubjectiveDetail.NomineeName]: [requiredTest('Nominee Name'), alphabetTest],
    investorName: [requiredTest('Investor name'), alphabetTest],
};

// export const getErrorMessage;
